import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import metadata from './CPMIMontanaClaimDetails.metadata.json5';

import styles from './CPMIMontanaClaimDetails.module.scss';



function CPMIMontanaClaimDetails(props) {
    const {
        claimantName,
        insuredName,
        claimNumber,
        lossDate,
        claimStatus,
        compensabilityStatus,
        adjuster,
        adjusterPhoneNumber,
        totalIncurred
    } = props;

    const overrideProps = {
        claimantName:{
            value: claimantName
        },
        insuredName:{
            value: insuredName
        },
        claimNumber:{
            value: claimNumber
        },
        dateOfLoss:{
            value: lossDate
        },
        claimStatus:{
            value: claimStatus
        },
        claimState:{
            value: compensabilityStatus
        },
        assignedAdjuster1:{
            value: adjuster
        },
        adjusterPhone1:{
            value: adjusterPhoneNumber
        },
        netToalIncurred:{
            value: totalIncurred
        }
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

CPMIMontanaClaimDetails.propTypes = {
    claimantName: PropTypes.string.isRequired,
    insuredName: PropTypes.string.isRequired,
    claimNumber: PropTypes.string.isRequired,
    lossDate: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    compensabilityStatus: PropTypes.string.isRequired,
    adjuster: PropTypes.string.isRequired,
    adjusterPhoneNumber: PropTypes.string.isRequired,
    totalIncurred: PropTypes.string.isRequired        
};

export default CPMIMontanaClaimDetails;
